import { find } from 'lodash';
import { ErrorLevel } from '../../models/';
import { WideError } from '../../common/';

export function computeError(value: number, bands: { min: number, max: number, level: ErrorLevel, message: string }[], isNaNZero: boolean = false): WideError | null {
    if (isNaNZero && isNaN(value)) {
        value = 0;
    }
    const band = find(bands, b => value >= b.min && value <= b.max);
    let wideError: WideError;
    if (!band) {
        wideError = new WideError(ErrorLevel.Error, 'Value is out of expected range');

    } else {
        wideError = new WideError(band.level, band.message);
    }
    return wideError;
}